<template>
  <section class="invoice-preview-wrapper mt-2">
    <b-row class="invoice-preview">

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir
          </b-button>
          <b-button
            v-if="tipoReporte == 4"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-prevent-closing
            variant="warning"
            class="mb-75"
            block
          >
            Agregar/Cambiar datos de firma
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="info"
            class="mb-75"
            block
            @click="loadAlumnos()"
          >
            Actualizar
          </b-button>
          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Note -->
          <b-card-body
            class="invoice-padding pt-0 text-center"
          >
            <span class="font-weight-bold">Nota: </span>
            <span>Recuerde que al firmar el documento, autoriza la información como legítima y válida.</span>
          </b-card-body>
          <!-- like footer -->
          <template #footer>
            <em>Al terminar puede cerrar esta ventana</em>
          </template>

        </b-card>
      </b-col>

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper m-0">
                  <logo />
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- lo que se imprime -->
          <b-overlay
            :show="showLoader"
            rounded="sm"
          >
            <b-table-lite
              responsive
              :items="salonreport"
              :fields="columnsCC"
              :busy="showLoader"
              show-empty
              empty-text="No se encontraron resultados"
            >
              <!-- Head -->
              <template #thead-top>
                <b-tr>
                  <b-th
                    colspan="4"
                  >
                    Posgrado: <code>{{ detallesCurso.plan.nombre }}</code>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th
                    colspan="2"
                  >
                    Asignatura: <code>{{ detallesCurso.curso.nombre }}</code>
                  </b-th>
                  <b-th
                    colspan="2"
                  >
                    Clave: <code>{{ detallesCurso.curso.clave }}</code>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th
                    colspan="4"
                  >
                    Cuatrimestre al que pertenece la asignatura: <code>{{ `${seleccionaCuatrimestre(detallesCurso.curso.orden)} ${detallesCurso.curso.temporalidad}` }}</code>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th
                    colspan="2"
                  >
                    Fecha de cierre del curso:  <code>{{ timestampToDate(detallesCurso.curso.fechaFin, 'L') }}</code>
                  </b-th>
                  <b-th colspan="2">
                    Periodo: <code> {{ detallesCurso.curso.clv_periodo }}</code>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th
                    colspan="2"
                  >
                    Profesor: <code>{{ detallesCurso.curso.profesor }}</code>
                  </b-th>
                  <b-th colspan="2">
                    Grupo: <code>{{ detallesCurso.curso.grupo }}</code>
                  </b-th>
                </b-tr>
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(nombre_completo)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.nombre_completo }}
                </b-card-text>
              </template>
              <template #cell(calif)="data">
                <b-card-text
                  v-for="item in data.item.calif"
                  :key="item.id"
                  class="font-weight-bold mb-25"
                >
                  <span v-show="data.item.calif.length > 1">Parcial: <code>{{ item.numParcial }}</code></span> <code>{{ (tipoReporte == 3)?((item.calif_profesor) ? item.calif_profesor : 'N/A'):(tipoReporte == 4)?((item.calif) ? item.calif : 'N/A') :'N/A' }}</code>
                </b-card-text>
                <b-card-text
                  v-show="data.item.calif.length <= 0"
                  class="font-weight-bold mb-25"
                >
                  SC
                </b-card-text>
              </template>
            </b-table-lite>
            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Note -->
            <b-card-body
              v-if="tipoReporte == 3"
              class="invoice-padding pt-0 text-center"
            >
              <span class="font-weight-bold">Nota: </span>
              <span>Este documento es para uso exclusivo del profesor titular</span>
            </b-card-body>
            <b-card-body class="invoice-padding mt-5 mb-5 pt-0 text-center">
              <span>___________________________________________________________________________________</span><br>
              <span>{{ (tipoReporte == 3)? 'Firma del profesor titular': cargoOpcional }}</span><br>
              <span> {{ (tipoReporte == 3)? detallesCurso.curso.profesor : nombreOpcional }}</span>
            </b-card-body>
            <b-card-body class="invoice-padding pt-0 text-center">
              <b-row class="m-0">
                <b-col>
                  <b-row class="text-black-50">
                    <b-col
                      md="12"
                      class="text-center m-2"
                    >
                      <h6>
                        Campus Virtual
                      </h6>
                      <h6>
                        Instituto para el Desarrollo Técnico de las Haciendas Públicas
                      </h6>
                    </b-col>
                  </b-row>
                  <b-row class="mb-0 text-center">
                    <b-col>
                      <p>
                        <span class="d-block d-md-inline-block mt-25">
                          Derechos Reservados © INDETEC  {{ new Date().getFullYear() }}
                        </span>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-overlay>
        </b-card>
        <b-modal
          id="modal-prevent-closing"
          ref="myModal"
          title="Cambiar los datos de firma"
          ok-title="Cambiar"
          cancel-variant="outline-secondary"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
        >
          <validation-observer ref="loginValidation">
            <form
              ref="form"
              @submit.prevent
            >
              <b-form-group
                :state="cargoState"
                label="Definición del cargo"
                label-for="cargo-input"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Definición de cargo"
                  rules="required"
                >
                  <b-form-input
                    id="cargo-input"
                    v-model="cargo"
                    :state="cargoState"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :state="nombreState"
                label="Nombre"
                label-for="nombre-input"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nombre"
                  rules="required"
                >
                  <b-form-input
                    id="nombre-input"
                    v-model="nombre"
                    :state="nombreState"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </form>
          </validation-observer>
        </b-modal>
      </b-col>

    </b-row>
  </section>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  ref, onMounted, computed,
} from '@vue/composition-api'
// import router from '@/router'
import {
  BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, VBToggle, BTr, BTh, BOverlay, BModal, VBModal, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'
import { useRouter, isEmptyObject } from '@core/utils/utils'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { timestampToDate } from '@core/utils/filter'
import { reportImpresoCalif, cabecerakardex } from './useReportes'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BModal,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BFormInput,
    BFormGroup,
    BTr,
    BTh,
    Logo,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    // InvoiceSidebarAddPayment,
    // InvoiceSidebarSendInvoice,
  },
  setup(_, { root, refs }) {
    const { route } = useRouter()
    const invoiceData = ref(null)
    const paymentDetails = ref({})
    const detallesCurso = ref({ plan: {}, curso: {} })
    const showLoader = ref(false)
    const toast = useToast()
    // catch values
    const inplan = (route.value.params.pl) ? route.value.params.pl : 0
    const incurso = (route.value.params.crs) ? route.value.params.crs : 0
    const inperiodo = (route.value.params.prd) ? route.value.params.prd : 0
    const tipoReporte = (route.value.params.tdr) ? route.value.params.tdr : 0

    // firma
    const cargoOpcional = ref('Firma del responsable')
    const nombreOpcional = ref('Nombre del responsable')
    const cargoState = ref(null)
    const cargo = ref('')
    const nombre = ref('')
    const nombreState = ref(null)

    const salonreport = ref([])
    const columnsCC = [
      {
        key: 'index',
        label: 'N.',
        sortable: true,
      },
      { key: 'nombre_completo', label: 'Nombre', sortable: true },
      { key: 'matricula', sortable: true },
      {
        key: 'calif', label: 'Calificación',
      },
    ]
    function seleccionaCuatrimestre(numero) {
      if (numero === 1) {
        return 'Primer'
      } if (numero === 2) {
        return 'Segundo'
      } if (numero === 3) {
        return 'Tercer'
      } if (numero === 4) {
        return 'Cuarto'
      } if (numero === 5) {
        return 'Quinto'
      } if (numero === 6) {
        return 'Sexto'
      }
      return ' '
    }

    // detalle del curso
    const CabeceraReport = () => {
      showLoader.value = true
      cabecerakardex(inplan, incurso).then(response => {
        detallesCurso.value = response
        showLoader.value = false
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [Información Curso]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }
    const form = ref('')

    const resetModal = () => {
      cargo.value = ''
      cargoState.value = null
      nombre.value = ''
      nombreState.value = null
    }
    const myModal = ref()
    const handleSubmit = () => {
      refs.loginValidation.validate().then(success => {
        cargoState.value = success
        nombreState.value = success
        if (cargo.value !== '') {
          cargoState.value = true
        }
        if (nombre.value !== '') {
          nombreState.value = true
        }
        if (!success) {
          return
        }
        // Push the name to submitted names
        cargoOpcional.value = cargo.value
        nombreOpcional.value = nombre.value
        // Hide the modal manually
        root.$nextTick(() => {
          myModal.value.hide()
        })
      })
    }
    const handleOk = bvModalEvt => {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      handleSubmit()
    }

    // get api participantes.js
    const loadAlumnos = () => {
      showLoader.value = true
      reportImpresoCalif(inplan, incurso, inperiodo).then(response => {
        salonreport.value = response.data
        showLoader.value = false
        CabeceraReport()
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [alumnos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }

    const printInvoice = () => {
      window.print()
    }
    const profesor = computed(() => store.getters['cuenta/getFullName'])

    onMounted(
      () => {
        loadAlumnos()
      },
    )

    return {
      invoiceData,
      paymentDetails,
      // data
      salonreport,
      detallesCurso,
      inperiodo,
      tipoReporte,
      columnsCC,
      profesor,
      // functions
      printInvoice,
      loadAlumnos,
      // flags
      showLoader,
      // tools
      isEmptyObject,
      // date
      timestampToDate,
      // firma
      cargoOpcional,
      nombreOpcional,
      cargoState,
      cargo,
      nombre,
      nombreState,
      // modal
      resetModal,
      handleOk,
      handleSubmit,
      myModal,
      form,
      required,
      seleccionaCuatrimestre,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }
  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  .buy-now > img {
    display:none;
  }
}
</style>
<style scoped>
  .headWhite {
      background-color: white !important;
    }
</style>
